module.exports = __webpack_public_path__ + "img/Blending-with-Benefits.494cef32.png";